/*
 * Durnev Cart Drawer — AJAX wiring for the side cart.
 *
 * Intercepts the quantity (±) and remove forms inside #overlay-cart so they
 * post to /cart/change.js instead of /cart, then refreshes the drawer DOM
 * from a fresh homepage fetch (the drawer is rendered as a snippet inside
 * the header section, so Sections API can't refresh it in isolation).
 *
 * Preserves the open/closed state across refreshes so the drawer doesn't
 * disappear after every click.
 */
(function () {
  'use strict';

  // The script is sourced from a snippet that gets re-inserted into the DOM
  // every time the drawer is refreshed (replaceWith brings the <script> back
  // and the browser re-executes it). Without this guard we'd attach a second
  // submit listener on every refresh and fire AJAX twice for the next click.
  if (window.__durnevCartDrawerInit) return;
  window.__durnevCartDrawerInit = true;

  // Meta Pixel: InitiateCheckout when the buyer proceeds to checkout from the
  // cart drawer. Delegated on document (capture) so it survives drawer
  // refreshes and still fires even though the kasa17 snippet intercepts the
  // checkout submit. Non-blocking — just reads the total and reports.
  document.addEventListener('click', function (e) {
    if (typeof window.fbq !== 'function') return;
    var btn = e.target && e.target.closest && e.target.closest('#overlay-cart [name="checkout"]');
    if (!btn) return;
    var totalEl = document.querySelector('#overlay-cart .durnev-cart__row-value--total');
    var value = 0;
    if (totalEl) {
      var digits = (totalEl.textContent || '').replace(/[^\d]/g, '');
      value = digits ? parseInt(digits, 10) : 0;
    }
    fbq('track', 'InitiateCheckout', { currency: 'UAH', value: value });
  }, true);

  function getDrawer() { return document.getElementById('overlay-cart'); }

  function isOpen() {
    var d = getDrawer();
    return d && d.classList.contains('is-open');
  }

  function reopen() {
    // After replaceWith() the fresh drawer is in the DOM without is-open,
    // but the overlay manager's internal openId is still 'cart' from before
    // the swap. Clicking the trigger would toggle and CLOSE the drawer —
    // that's exactly what made + and − dismiss the cart. Flip the class
    // directly so manager state stays consistent with what's visible.
    var d = getDrawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
  }

  function updateBadge(freshDoc) {
    var sel = '[data-cart-count], .durnev-header__bag-count, .durnev-header__bag';
    var fresh = freshDoc.querySelector(sel);
    var current = document.querySelector(sel);
    if (fresh && current) current.textContent = fresh.textContent;
  }

  function refreshDrawer() {
    var wasOpen = isOpen();
    return fetch('/', { headers: { 'Accept': 'text/html' }, cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('overlay-cart');
        var current = getDrawer();
        if (!fresh || !current) return;
        current.replaceWith(fresh);
        updateBadge(doc);
        if (wasOpen) reopen();
      });
  }

  // ─── Quantity ± and Remove ───────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.durnev-cart__qty-form, .durnev-cart__remove-form')) return;
    e.preventDefault();

    var fd = new FormData(form);

    // For qty forms there are two submit buttons (− and +) sharing the same
    // name — the browser only includes the clicked one in FormData when a
    // real click happens, but `e.submitter` is the reliable source.
    if (e.submitter && e.submitter.name) {
      fd.set(e.submitter.name, e.submitter.value);
    }

    // Disable all submit buttons in the drawer so a fast double-tap doesn't
    // queue two updates.
    var drawer = getDrawer();
    var allBtns = drawer ? drawer.querySelectorAll('button[type="submit"]') : [];
    allBtns.forEach(function (b) { b.disabled = true; });

    fetch('/cart/update.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { var d = j.description || j.message || 'Помилка'; throw new Error((window.durnevTranslateCartError || function(m){return m;})(d)); });
        return r.json();
      })
      .then(refreshDrawer)
      .catch(function (err) {
        alert(err.message || 'Не вдалось оновити кошик');
        allBtns.forEach(function (b) { b.disabled = false; });
      });
  });
})();
